exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/core-js@2.6.12/~/core-js/library/modules/_object-pie.js
// module id = 56
// module chunks = 1 2 3